export default {
	dev: {
		global: 'https://dev-www.nexon.com',
		one: 'https://dev-one.nexon.com',
		th: 'https://dev-th.nexon.com',
		tw: 'https://dev-tw.nexon.com',
		sea: 'https://dev-sea.nexon.com',
		japan: 'https://dev-japan.nexon.com',
	},
	testPre: {
		global: 'https://test-pre-www.nexon.com',
		one: 'https://test-pre-one.nexon.com',
		th: 'https://test-pre-th.nexon.com',
		tw: 'https://test-pre-tw.nexon.com',
		sea: 'https://test-pre-sea.nexon.com',
		japan: 'https://test-pre-japan.nexon.com',
	},
	test: {
		global: 'https://test-www.nexon.com',
		one: 'https://test-one.nexon.com',
		th: 'https://test-th.nexon.com',
		tw: 'https://test-tw.nexon.com',
		sea: 'https://test-sea.nexon.com',
		japan: 'https://test-japan.nexon.com',
	},
	pre: {
		global: 'https://pre-www.nexon.com',
		one: 'https://pre-one.nexon.com',
		th: 'https://pre-th.nexon.com',
		tw: 'https://pre-tw.nexon.com',
		sea: 'https://pre-sea.nexon.com',
		japan: 'https://pre-japan.nexon.com',
	},
	prod: {
		global: 'https://www.nexon.com',
		one: 'https://one.nexon.com',
		th: 'https://th.nexon.com',
		tw: 'https://tw.nexon.com',
		sea: 'https://sea.nexon.com',
		japan: 'https://japan.nexon.com',
	},
};
